import React, { Component, ReactNode } from 'react';
import Block from '../Block';
import ToolbarContext, { ToolbarContextType } from '../ToolbarContext';

import {
  FadeTransition,
  Toolbar,
  ToolbarSeparator,
  WithStyles,
  createStyles,
  cx,
  overRefs,
  withStyles,
} from '@robotsnacks/ui';

const styles = createStyles<'root' | 'title'>(() => ({
  root: {
    fontSize: 12,
    display: 'inline-flex',
    marginRight: '0.5rem',
  },
  title: {
    fontSize: 10,
    fontWeight: 700,
    padding: '0 4px 0 3px',
    userSelect: 'none',
  },
}));

export interface BlockToolbarProps {
  block: Block;
  children?: ReactNode;
  className?: string;
  parentItems?: ReactNode;
  title: ReactNode;
}

type Props = WithStyles<BlockToolbarProps, typeof styles>;

class BlockToolbar extends Component<Props> {
  private _ctx: ToolbarContextType | null = null;
  private _domRef: HTMLElement | null = null;

  componentWillUnmount() {
    if (this._domRef) {
      this._domRef.removeEventListener(
        'taffy:flyout:opened',
        this._handleFlyoutOpened,
      );
      this._domRef.removeEventListener(
        'taffy:flyout:closing',
        this._handleFlyoutClosed,
      );
    }
    if (this._ctx) this._ctx.blur(this.props.block);
  }

  render() {
    const { title, children, classes, className, parentItems } = this.props;
    return (
      <ToolbarContext.Consumer>
        {context => {
          this._ctx = context;
          return (
            <FadeTransition
              mountOnEnter
              unmountOnExit
              in={context.isIn(this.props.block)}
              onEnterDone={this._handleEnterDone}
            >
              {({ className: transitionClassName, domRef, ...rest }) => (
                <Toolbar
                  rounded
                  className={cx(classes.root, transitionClassName, className)}
                  domRef={overRefs(domRef, this._setDOMRef)}
                  elevation={5}
                  {...rest}
                >
                  {title && <div className={classes.title}>{title}</div>}
                  <ToolbarSeparator />
                  {parentItems}
                  {parentItems && <ToolbarSeparator />}
                  {children}
                </Toolbar>
              )}
            </FadeTransition>
          );
        }}
      </ToolbarContext.Consumer>
    );
  }

  private _setDOMRef = (el: HTMLElement | null) => {
    this._domRef = el;
  };

  private _handleEnterDone = () => {
    if (this._domRef) {
      this._domRef.addEventListener(
        'taffy:flyout:opened',
        this._handleFlyoutOpened,
      );
      this._domRef.addEventListener(
        'taffy:flyout:closing',
        this._handleFlyoutClosed,
      );
    }
  };

  private _handleFlyoutOpened = () => {
    if (this._ctx) {
      this._ctx.focus(this.props.block);
    }
  };

  private _handleFlyoutClosed = () => {
    if (this._ctx) {
      this._ctx.blur(this.props.block);
    }
  };
}

export default withStyles(styles)(BlockToolbar);
